import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    modelTypeList: [],
    advanceEntryNumber: "",
    errorMessage: ""
  },
  getters: {
    getModelTypeList (state) {
      return state.modelTypeList || []
    },
    getModelTypeListOption (state) {
      let modelTypeList = state.modelTypeList
      let options = [{label: '選択してください', value: '', disabled: true}]
      for (let modelType of modelTypeList) {
        options.push( {label: modelType, value: modelType, disabled: false} )
      }
      return options
    },
    getAdvanceEntryNumber (state) {
      return state.advanceEntryNumber || ""
    },
    getErrorMessage (state) {
      return state.errorMessage || ""
    }
  },
  mutations: {
    setModelTypeList (state, modelTypeList) {
      state.modelTypeList = modelTypeList || []
    },
    setAdvanceEntryNumber (state, advanceEntryNumber) {
      state.advanceEntryNumber = advanceEntryNumber || ""
    },
    setErrorMessage (state, errorMessage) {
      state.errorMessage = errorMessage || ""
    },
  },
  actions: {
    setModelTypeList ({commit}, modelTypeList) {
      commit('setModelTypeList', modelTypeList)
    },
    setAdvanceEntryNumber ({commit}, advanceEntryNumber) {
      commit('setAdvanceEntryNumber', advanceEntryNumber)
    },
    setErrorMessage ({commit}, errorMessage) {
      commit('setErrorMessage', errorMessage)
    },
  }
})
